import { useQuery } from '@tanstack/react-query';

import { SCHEDULED_ORDERS_STALE_TIME_MS, ScheduleTab } from '../domain';
import { scheduleOrderAdapter } from '../infra/adapters';
import { scheduleOrderService, scheduleQueryKeys } from '../infra/services';

import { useScheduledStoreIds } from './useScheduledStoreIds';
import { useScheduleTab } from './useScheduleTab';

export function useScheduledOrdersQuery() {
  const storeIds = useScheduledStoreIds();
  const { activeTab } = useScheduleTab();

  return useQuery({
    queryKey: scheduleQueryKeys.list(storeIds),
    queryFn: () => scheduleOrderService.listScheduledOrders(storeIds),
    select: data => data.map(scheduleOrderAdapter.toScheduledOrder),
    enabled: activeTab === ScheduleTab.Scheduled && storeIds.length > 0,
    staleTime: SCHEDULED_ORDERS_STALE_TIME_MS,
  });
}
